export default __webpack_public_path__ + "static/805-599d575c37d35e7b1ab873badee20136.gif";